export const setModal = (content, closable = true) => ({
    type: 'MODAL.SET',
    content,
    closable,
});
